import React from 'react';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { selectExpandedAccordionFromDetailState, selectSimCardContent } from 'component/page/detail/store/detail.selectors';
import DetailInViewWrapper from 'component/common/DetailInViewWrapper/DetailInViewWrapper';
import { Accordion, Divider } from '@drone-js/core';
import { DetailContentOnToggleProps } from 'component/page/detail/DetailPageContent/DetailPageContent.selectors';
import { NavigationHashEnum } from 'core/type/Details.types';
import {
    ActivitiesSimCardContainerClickEventActivitiesManifestV1,
    ActivitiesSimCardContainerSeenEventActivitiesManifestV1,
} from '@agoda/analytics-messages-definition-activities/manifest/events';
import { trackElementEvent } from 'core/messaging/analytics/analytics';
import { ActivitiesSimCardContainerSeenEventActivitiesFieldsV1 } from '@agoda/analytics-messages-definition-activities/events.split';
import { setSelectedTabOnDetailsPage } from 'component/page/detail/store/details';
import { InView } from 'react-intersection-observer';
import { SimCardContent } from 'component/page/detail/MoreInfoSections/SimCardSpecification/SimCardContent';

const SimCardSpecification: React.FC<DetailContentOnToggleProps> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);
    const simCardContent = useSelector(selectSimCardContent);
    const expandedAccordion = useSelector(selectExpandedAccordionFromDetailState);
    const simCardSpecSectionState = expandedAccordion[`#${props.href}` || ''] ? 'expanded' : 'collapsed';
    const simCardEventIds = ActivitiesSimCardContainerSeenEventActivitiesManifestV1.ids;

    const onSeen = (inView: boolean) => {
        if (inView && simCardContent && simCardContent.length > 0) {
            trackElementEvent<ActivitiesSimCardContainerSeenEventActivitiesFieldsV1>(simCardEventIds, { is_toggle_on: simCardSpecSectionState === 'expanded' });
        }
    };

    if (!simCardContent.length) {
        return null;
    }

    return (
        <InView onChange={onSeen} triggerOnce={true} threshold={1}>
            <DetailInViewWrapper tabHref={props.href || ''} isScrolling={props.isScrolling} setSelectedTabCallback={setSelectedTabOnDetailsPage}>
                <Accordion
                    id={props.href}
                    actionType="chevron-icon"
                    data-element-name="activities-sim-card-container"
                    data-testid="activities-sim-card-container"
                    contentSummary={cms[244232] || ''}
                    backgroundColor="base.surface"
                    level={2}
                    view={simCardSpecSectionState}
                    onToggle={props.onToggle(NavigationHashEnum.SimCardSpecSection, ActivitiesSimCardContainerClickEventActivitiesManifestV1.ids)}
                >
                    {simCardContent.map((content, index) => (
                        <SimCardContent key={index} content={content} index={index} maxItems={simCardContent.length} />
                    ))}
                </Accordion>
                <Divider direction="horizontal" my="4" />
            </DetailInViewWrapper>
        </InView>
    );
};
SimCardSpecification.displayName = 'SimCardSpecification';

export default SimCardSpecification;
